import type { ABTests } from '@fiverr-private/fiverr_context';
import { EXPERIMENTS, MIXPANEL_RECORD_SESSION_PERCENT } from './constants';

export function getMixpanelRecordSessionPercent(abTests: ABTests): number {
    const isInCheetahsBookPublishingExperiment = Number(abTests[EXPERIMENTS.CHEETAHS_BOOK_PUBLISHING]) === 2;

    if (isInCheetahsBookPublishingExperiment) {
        return 100;
    }

    return MIXPANEL_RECORD_SESSION_PERCENT;
}
